import React from "react";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import FilterAccordion from "./FilterAccordion";
import { channelHelperText } from "../Inbox/Utilities/inboxUtils";

export default function ChannelsFilter({
  groups = [],
  selectedLabels = [],
  onChange,
}) {
  if (!groups.length) return null;

  const activeLabels = groups
    .filter((group) => selectedLabels.includes(group.label))
    .map((group) => group.label);

  function toggleGroup(label) {
    const nextLabels = activeLabels.includes(label)
      ? activeLabels.filter((item) => item !== label)
      : [...activeLabels, label];
    onChange?.(nextLabels);
  }

  return (
    <FilterAccordion
      label="Channels"
      helperText={channelHelperText(groups, activeLabels)}
    >
      <Box>
        {groups.map((group) => (
          <FormControlLabel
            key={group.label}
            sx={styles.label}
            label={group.label}
            labelPlacement="start"
            control={
              <Checkbox
                checked={activeLabels.includes(group.label)}
                onChange={() => toggleGroup(group.label)}
                sx={styles.checkbox}
              />
            }
          />
        ))}
      </Box>
    </FilterAccordion>
  );
}

const styles = {
  label: {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.8125rem",
      fontFamily: "FustatMedium",
      color: "#33413a",
    },
    width: "100%",
    margin: 0,
    justifyContent: "space-between",
  },
  checkbox: {
    color: "#aeaeae",
    "&.Mui-checked": {
      color: "#003300",
    },
  },
};
